import { G_LOGIN_START, G_LOGIN_SUCCESS, G_LOGIN_ERROR, G_LOGIN_RESET } from "./constant"

export const gLoginStart = (payload, history )=> {
  return {
    type: G_LOGIN_START,
    payload: {payload, history},
  }
}
export const gLoginSuccess = payload => {
  console.log(payload)
  return {
    type: G_LOGIN_SUCCESS,
    payload,
  }
}
export const gLoginError = payload => {
  return {
    type: G_LOGIN_ERROR,
    payload,
  }
}

export const gLoginReste = payload => {
  return {
    type: G_LOGIN_RESET,
    payload,
  }
}

